import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import utils from '../../utils/utils';

import { connect } from 'react-redux';
import ITEM_TEMPERATURE from '../../components/constants/itemTemperature';
import { saveAs } from 'file-saver';
import { pdf } from '@react-pdf/renderer';
import PackerDeliveryDayMarketplacePdf from './packerDeliveryDayMarketplacePdf';
import { useCombinedOrderItems } from './apiHooks';
import Loader from '../../components/loader';
import ErrorMessage from '../../components/errorMessage';
import PackerCombinedOrderItemsTable from './packerCombinedOrderItemsTable';

const PackerDeliveryDayMarketplaceCombinedOrderItems = ({ match, intl, deliveryDayMarketplace }) => {
  const { combinedOrderItems, isLoading, isError, error } = useCombinedOrderItems({
    deliveryDayMarketplaceId: deliveryDayMarketplace?.id,
    refetchInterval: 60000,
  });

  const {
    combinedOrderItems: combinedOrderItemsMinusExcluded,
    isLoading: excludedLoading,
    isError: isExcludedError,
    error: excludedError,
  } = useCombinedOrderItems({
    deliveryDayMarketplaceId: deliveryDayMarketplace?.id,
    excludeOrdersInPacking: true,
    refetchInterval: 60000,
  });

  const tempEnums = Object.keys(ITEM_TEMPERATURE).map((key) => ITEM_TEMPERATURE[key]);

  return (
    <div>
      <Loader show={isLoading || excludedLoading} />
      {isError || isExcludedError ? (
        <ErrorMessage error={utils.getErrorMessageFromResponse(error || excludedError)} />
      ) : (
        ''
      )}

      <div className="m-b-3">
        {combinedOrderItems?.length && deliveryDayMarketplace ? (
          <button
            className="btn btn-primary m-r-2"
            onClick={async () => {
              const doc = (
                <PackerDeliveryDayMarketplacePdf
                  combinedOrderItems={combinedOrderItems}
                  deliveryDayMarketplace={deliveryDayMarketplace}
                  copy={utils.getPackerDeliveryDayMarketplacePdfCopy(intl)}
                />
              );
              const asPdf = pdf(); // {} is important, throws without an argument
              asPdf.updateContainer(doc);
              const blob = await asPdf.toBlob();
              saveAs(blob, `ddm-${match.params.deliveryDayMarketplaceId}.pdf`);
            }}
          >
            <FormattedMessage id={'packer.delivery.day.marketplace.cta.download.pdf'} />
          </button>
        ) : (
          ''
        )}
      </div>

      {combinedOrderItems ? (
        <div className="row m-b-6">
          <div className="col-12 col-sm-10 col-md-8 col-lg-6">
            <PackerCombinedOrderItemsTable
              combinedOrderItems={combinedOrderItems}
              combinedOrderItemsMinusExcluded={combinedOrderItemsMinusExcluded}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

PackerDeliveryDayMarketplaceCombinedOrderItems.propTypes = {
  currentUser: PropTypes.object,
  deliveryDayMarketplace: PropTypes.object.isRequired,
};

PackerDeliveryDayMarketplaceCombinedOrderItems.defaultProps = {};

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser.user,
  };
}

export default injectIntl(connect(mapStateToProps)(PackerDeliveryDayMarketplaceCombinedOrderItems));
